import { InstrumentDescriptionUtils } from '../../Instruments/InstrumentDescriptionUtils';
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class WatchlistSheetItem {
    constructor(name, instDecriptions = []) {
        this._availableInstrumentMap = null;
        this.name = name;
        this._instrumentMap = new Map(instDecriptions.map((desc) => [this.getMapKey(desc), desc]));
    }
    getInstrumentDescriptions() {
        return [...this._instrumentMap.values()];
    }
    getAvailableInstrumentDescriptions() {
        return isNullOrUndefined(this._availableInstrumentMap)
            ? this.getInstrumentDescriptions()
            : [...this._availableInstrumentMap.values()];
    }
    setAvailableInstrumentDescriptions(instrDescriptions) {
        this._availableInstrumentMap = new Map(instrDescriptions.map((desc) => [this.getMapKey(desc), desc]));
    }
    has(interiorId) {
        return this._instrumentMap.has(interiorId);
    }
    add(instDescr) {
        var _a;
        const key = this.getMapKey(instDescr);
        this._instrumentMap.set(key, instDescr);
        (_a = this._availableInstrumentMap) === null || _a === void 0 ? void 0 : _a.set(key, instDescr);
    }
    delete(instDescr) {
        var _a;
        const key = this.getMapKey(instDescr);
        this._instrumentMap.delete(key);
        (_a = this._availableInstrumentMap) === null || _a === void 0 ? void 0 : _a.delete(key);
    }
    set(instrDescriptions) {
        this._instrumentMap.clear();
        this._availableInstrumentMap = null;
        for (const instDescr of instrDescriptions) {
            const key = this.getMapKey(instDescr);
            this._instrumentMap.set(key, instDescr);
        }
    }
    clear() {
        var _a;
        this._instrumentMap.clear();
        (_a = this._availableInstrumentMap) === null || _a === void 0 ? void 0 : _a.clear();
    }
    getMapKey(instDescr) {
        return InstrumentDescriptionUtils.createInteriorId(instDescr);
    }
}
